import { 
    Box,
    Divider,
} from '@mui/material';
import {
    DeleteButton,
    EditButton,
    ShowButton,
    useRecordContext,
    Button,
} from 'react-admin';
import {
    useCreatePath,
} from 'ra-core';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { useLocation } from 'react-router';
import { Role } from '@/types';

export const RoleAside = ({ link = 'edit' }: { link?: 'edit' | 'show' }) => {
    const location = useLocation();
    const record = useRecordContext<Role>();
    if (!record) return null;

    const createPath = useCreatePath();
    const stopPropagation = (e: any) => e.stopPropagation();

    return (
        <Box ml={4} width={250} minWidth={250}>
            {link !== 'edit' ? (
                <></>
            ) : (
                <>
                    <Box my={2}>
                        <Button
                            component={Link}
                            to={createPath({ resource: 'roles', type: 'list' })}
                            label={'Back'}
                            onClick={stopPropagation}>
                            <ArrowBackIcon />
                        </Button>
                    </Box>
                    <Divider />
                </>
            )}
            <Box my={2}>
                {link === 'edit' ? (
                    <EditButton label="Edit Role" />
                ) : (
                    <ShowButton label="Show Role" />
                )}
                <br/>
                <DeleteButton mutationMode="pessimistic" redirect={location.state?.from || undefined} />
            </Box>
        </Box>
    );
};
